import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ScheduleCreateContext, ScheduleCreateValues } from '../../contexts/ScheduleCreateContext';
import { useContext } from 'react';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

const ScheduleCreateDeleteCountZoneTypesModal = () => {
  const { isCountZoneTypesDeleteModalOpen,
    handleClose,
    deleteCountZoneTypes } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  const { t } = useTranslation('createStockCountSchedule');

  return (
    <Dialog open={isCountZoneTypesDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('countZoneTypes.delete')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <Typography>{t('countZoneTypes.deleteMessage')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}> {t('cancel')}</Button>
        <Button variant="bad"
          size='lg'
          onClick={deleteCountZoneTypes}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleCreateDeleteCountZoneTypesModal;
